import type { EntryGroupEntry } from "@/shared/cache";

type DayTotalEntry = Pick<EntryGroupEntry, "id" | "date" | "status" | "units">;

/** Include every active group once, replacing the edited group with its draft. */
export function projectedDayTotal(
	entries: readonly DayTotalEntry[],
	date: string,
	draftUnits: number,
	editedGroupId?: string | null,
): number {
	const savedUnits = entries.reduce((total, entry) => {
		if (
			entry.date !== date ||
			entry.id === editedGroupId ||
			entry.status === "deleted"
		)
			return total;
		return total + entry.units;
	}, 0);
	return Math.round((savedUnits + draftUnits) * 100) / 100;
}
